import { Icon, IconProps } from './Icon';

export const ElectricityIcon = ({ color = 'currentColor', ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M17.8496 6.40039V10.125C17.8496 11.1129 17.4574 12.0602 16.7588 12.7588C16.0602 13.4574 15.1129 13.8496 14.125 13.8496H12.874C11.8863 13.8493 10.9386 13.4573 10.2402 12.7588C9.54196 12.0603 9.15039 11.1127 9.15039 10.125V6.40039H17.8496Z"
      stroke={color}
      strokeWidth="1.3"
      fill="none"
    />
  </Icon>
);
